import * as React from "react";
import { Link } from "gatsby";
import * as blobs2 from "blobs/v2";
import { transparentize } from "polished";
import { getEventAttributes, EventCategory } from "../../../utils/analytics";
import { Colors } from "../../design-tokens/colors";
import Image from "../image/image";
import styles from "./category-card.styles";

interface CategoryCardProps {
  name: string;
  url: string;
  imageUrl: string;
  imagePosition: string;
  description: string;
  eventCategory: EventCategory;
}

const CategoryCard: React.FC<CategoryCardProps> = ({
  name,
  url,
  imageUrl,
  imagePosition,
  description,
  eventCategory,
}) => {
  const blob1 = blobs2.svg(
    {
      seed: Math.random(),
      extraPoints: 10,
      randomness: 10,
      size: 180,
    },
    { fill: transparentize(0.6, Colors.DarkBlueHeader) }
  );

  const blob2 = blobs2.svg(
    {
      seed: Math.random(),
      extraPoints: 8,
      randomness: 8,
      size: 160,
    },
    { fill: transparentize(0.4, Colors.DarkBlueHeader) }
  );

  const isTop = imagePosition === "top";

  return (
    <Link
      to={url}
      css={styles.root}
      {...getEventAttributes({
        category: eventCategory,
        action: "Click - Category card",
        label: name,
      })}
    >
      <div css={styles.content}>
        <div css={styles.heading}>{name}</div>
        <div>{description}</div>
      </div>
      <div
        css={[styles.blob1, isTop ? styles.blob1Top : styles.blob1Bottom]}
        dangerouslySetInnerHTML={{
          __html: blob1,
        }}
      ></div>
      <div
        css={[styles.blob2, isTop ? styles.blob2Top : styles.blob2Bottom]}
        dangerouslySetInnerHTML={{
          __html: blob2,
        }}
      ></div>
      <Image
        css={[styles.image, isTop ? styles.imageTop : styles.imageBottom]}
        src={imageUrl}
        turnOffLazyLoading={true}
        alt={name}
      />
    </Link>
  );
};

export default CategoryCard;
